'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCommunityCollectDependencies;

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCommunityCollectDependencies(_ref) {
  var data = _ref.data,
      dependencies = _ref.dependencies,
      builderData = _ref.builderData;

  var results = {};

  if (dependencies.includes('area')) {
    var communityAreas = _fp2.default.map(function (item) {
      return { name: _fp2.default.get('area', item) };
    })(data);
    var areas = _fp2.default.flow(_fp2.default.intersectionBy('name', _fp2.default, communityAreas), _fp2.default.uniq)(builderData.areas);

    results.areas = areas;
  }

  if (dependencies.includes('homes')) {
    var communityIds = _fp2.default.map(function (item) {
      return { _id: _fp2.default.get('_id', item) };
    })(data);
    var homes = _fp2.default.flow(_fp2.default.intersectionBy('containedIn', _fp2.default, communityIds), _fp2.default.uniq)(builderData.homes);

    results.homes = homes;
  }

  // if (dependencies.includes('plans')) {
  //   const planIds = _.map(item => ({ 'communities.community': _.get('plan', item) }))(data);
  //   const plans = _.flow(
  //     _.intersectionBy('_id', _, planIds),
  //     _.uniq,
  //   )(_.get('plans.data')(state));
  //
  //   results.plans = plans;
  // }

  return results;
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Communities/filters/getCommunityCollectDependencies.js
// module id = 807
// module chunks = 0